import React, { useState } from "react";
import { Popover, PopoverBody, PopoverHeader } from "reactstrap";

const CalculationPopover = ({
  targetId,
  title,
  formula,
  calculation,
  description,
  placement = "auto",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        id={targetId}
        type="button"
        className="btn btn-link border-0 p-0 ml-1 text-muted"
        onClick={() => setIsOpen(true)}
        aria-label={`View ${title.toLowerCase()}`}
        title="View calculation"
      >
        <i className="fa fa-calculator" />
      </button>

      <Popover
        placement={placement}
        target={targetId}
        isOpen={isOpen}
        toggle={() => setIsOpen((open) => !open)}
        container="body"
        modifiers={{
          preventOverflow: { boundariesElement: "viewport" },
        }}
        style={{ zIndex: 2000 }}
      >
        <PopoverHeader>
          <div className="d-flex align-items-center justify-content-between" style={{ width: "100%" }}>
            <span>{title}</span>
            <button
              type="button"
              className="close ml-3"
              aria-label={`Close ${title.toLowerCase()}`}
              onClick={() => setIsOpen(false)}
              style={{ fontSize: "20px", lineHeight: 1 }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </PopoverHeader>
        <PopoverBody>
          {formula && <div className="text-muted small mb-2">{formula}</div>}
          {calculation && <div className="font-weight-bold mb-2">{calculation}</div>}
          {description && <div>{description}</div>}
        </PopoverBody>
      </Popover>
    </>
  );
};

export default CalculationPopover;
